import v1 from './1';
import v2 from './2';
import v3 from './3';
import v4 from './4';
import v5 from './5';
import v6 from './6';

export default Object.freeze([v1, v2, v3, v4, v5, v6]);
